<template>
  <div class="contents">
    <div :ref="`p1-tooltip-icon-${id}`">{{ $t('projectOne.B2B.order.btoIcon.hover') }}</div>
    <pdl-icon
      v-tippy="{
        allowHTML: true,
        content: getP1TooltipIconElement,
        interactive: true,
        trigger: 'mouseenter focus',
        popperOptions: {
          modifiers: [
            {
              name: 'flip',
              enabled: true,
            },
          ],
        },
        sticky: true,
        theme: 'light left-align',
      }"
      name="project_one_colorwheel"
      size="18"
      class="filter grayscale flex-none self-center cursor-pointer mr-1"
      :qaid="`p1-tooltip-icon-${id}`"
    />
  </div>
</template>

<script>
import {PdlIcon} from '@pedal/pdl-icon';

export default {
  components: {
    PdlIcon,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  methods: {
    getP1TooltipIconElement() {
      return this.$refs[`p1-tooltip-icon-${this.id}`];
    },
  },
};
</script>
